import React from 'react';
import { Box, keyframes } from '@mui/material';
import { useHomeLogo } from '../../hooks/useHomeLogo';
import MovingTarget from '../../components/MovingTarget';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const HomeHeader = () => {
  const logoUrl = useHomeLogo();

  return (
    <Box sx={{ width: '100%', mt: 2, mb: 2, display: 'flex', justifyContent: 'center', position: 'relative' }}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          maxHeight: '220px',
          display: 'flex',
          justifyContent: 'center',
          minHeight: '100px'
        }}
      >
        {logoUrl && (
          <img
            src={logoUrl}
            alt="Rezone Logo"
            style={{
              width: 'auto',
              maxWidth: '100%',
              maxHeight: '220px',
              objectFit: 'contain',
              position: 'relative',
              zIndex: 1,
              opacity: 1,
              animation: `${fadeIn} 0.5s ease-in`
            }}
          />
        )}
        <MovingTarget />
      </Box>
    </Box>
  );
};

export default HomeHeader;
